import { __assign } from 'tslib';
import { makeStyles, Box } from '@material-ui/core';
import classNames from 'classnames';
import React from 'react';
import { Typography } from '../Typography/Typography.js';

var SemanticColors;
(function (SemanticColors) {
    SemanticColors["PRIMARY_MAIN"] = "primary.main";
    SemanticColors["PRIMARY_DARK"] = "primary.dark";
    SemanticColors["PRIMARY_LIGHT"] = "primary.light";
    SemanticColors["SECONDARY_MAIN"] = "secondary.main";
    SemanticColors["SECONDARY_DARK"] = "secondary.dark";
    SemanticColors["SECONDARY_LIGHT"] = "secondary.light";
})(SemanticColors || (SemanticColors = {}));
var useStyles = makeStyles(function (theme) { return ({
    dividerRoot: {
        gap: theme.spacing(2),
    },
    textRoot: {
        color: function (props) {
            var textColor = props.textColor;
            if (Object.values(SemanticColors).includes(textColor)) {
                var _a = textColor.split('.'), semanticColor = _a[0], shade = _a[1];
                // @ts-expect-error - todo.
                return theme.palette[semanticColor][shade];
            }
            else if (textColor) {
                return textColor;
            }
            else {
                return 'black';
            }
        },
        textTransform: function (props) { return props.textTransform; },
    },
    dividerLine: {
        backgroundColor: function (props) {
            var dividerColor = props.dividerColor;
            if (Object.values(SemanticColors).includes(dividerColor)) {
                var _a = dividerColor.split('.'), semanticColor = _a[0], shade = _a[1];
                // @ts-expect-error - todo.
                return theme.palette[semanticColor][shade];
            }
            else if (dividerColor) {
                return dividerColor;
            }
            else {
                return theme.palette.grey[500];
            }
        },
    },
}); });
var Divider = function (props) {
    var className = props.className, text = props.text, textTransform = props.textTransform, TypographyProps = props.TypographyProps;
    var classes = useStyles(props);
    var casingOffset = textTransform === 'lowercase' ? '.25rem' : 'unset';
    return (React.createElement(Box, { className: classNames([classes.dividerRoot, className]), display: "flex", alignItems: "center" },
        React.createElement(Box, { className: classes.dividerLine, display: "flex", flexGrow: 1, height: "1px", marginTop: casingOffset }),
        text && (React.createElement(React.Fragment, null,
            React.createElement(Typography, __assign({ className: classes.textRoot }, TypographyProps), text),
            React.createElement(Box, { className: classes.dividerLine, display: "flex", flexGrow: 1, height: "1px", marginTop: casingOffset })))));
};
Divider.displayName = 'Divider';
Divider.defaultProps = {
    textTransform: 'lowercase',
};

export { Divider };
//# sourceMappingURL=Divider.js.map
